import React from "react";
import { createRoot } from "react-dom/client";
import { AlertTriangle } from "lucide-react";

const Dialog = ({ message, onResolve }) => (
  <div className="fixed inset-0 z-[100] flex items-center justify-center px-4"
       data-testid="confirm-elite-dialog">
    <div className="absolute inset-0 bg-[#060A14]/85 backdrop-blur-sm" onClick={() => onResolve(false)} />
    <div className="relative w-full max-w-sm bg-[#0A1121] border border-[#C0C0C0]/25 rounded-md p-6 shadow-2xl animate-in fade-in zoom-in-95 duration-200">
      <div className="flex items-start gap-3">
        <span className="w-9 h-9 shrink-0 rounded-full bg-red-500/10 border border-red-500/30 flex items-center justify-center">
          <AlertTriangle className="w-4 h-4 text-red-300" strokeWidth={1.5} />
        </span>
        <div>
          <p className="text-[10px] tracking-[0.32em] uppercase text-[#C0C0C0]">Conferma richiesta</p>
          <p className="mt-2 text-[13px] leading-relaxed text-[#E5E4E2]">{message}</p>
        </div>
      </div>
      <div className="mt-6 flex justify-end gap-2">
        <button type="button" onClick={() => onResolve(false)} data-testid="confirm-elite-cancel"
                className="px-4 py-2.5 rounded-sm text-[10px] tracking-[0.24em] uppercase border border-white/15 text-[#94A3B8] hover:text-white hover:border-white/30">
          Annulla
        </button>
        <button type="button" onClick={() => onResolve(true)} data-testid="confirm-elite-confirm"
                className="px-5 py-2.5 rounded-sm text-[10px] tracking-[0.24em] uppercase bg-red-500/90 text-white hover:bg-red-500 font-medium">
          Conferma
        </button>
      </div>
    </div>
  </div>
);

/** Themed replacement for window.confirm(). Usage: if (!(await confirmElite("..."))) return; */
export const confirmElite = (message) =>
  new Promise((resolve) => {
    const host = document.createElement("div");
    document.body.appendChild(host);
    const root = createRoot(host);
    const done = (val) => {
      root.unmount();
      host.remove();
      resolve(val);
    };
    root.render(<Dialog message={message} onResolve={done} />);
  });

export default confirmElite;
